"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    for (var key in listeners) {
      // $FlowFixMe
      var listener = listeners[key];
      /* istanbul ignore if */

      if (listener === undefined) {
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }
  /* istanbul ignore next */


  return {
    publish: publish,
    subscribe: subscribe,
    unsubscribe: function unsubscribe(unsubID) {
      listeners[unsubID] = undefined;
    }
  };
};

exports.default = createBroadcast;